














































































import Vue from 'vue'
import { DatePeriod } from '@/model/DatePeriod'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import moment from 'moment'
import { DatePeriodEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { CREATE_INVOICES, FETCH_INVOICING_DATA, FETCH_INVOICING_STATUS } from '@/store/action-types'
import { Invoice } from '@/model/planning/Invoice'
import { CreateInvoicesPayload, InvoiceDataPayload, InvoicePayload } from '@/types/payload'
import { Invoicing } from '@/model/planning/Invoicing'
import { InvoicingDetail } from '@/model/planning/InvoicingDetail'
import { TranslateResult } from 'vue-i18n'
import { InvoiceResponse, InvoiceStatusResponse, ResponseBase } from '@/types/service-response'

interface ComponentData {
  positions: any
  loading: boolean
  isSaveInProgress: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  gridDataClosed: Invoicing[]
  gridDataNotClosed: Invoicing[]
  headers: any
  overlayNoRowsTemplate: string
  period: DatePeriod | undefined
  closedSelected: Invoicing[]
  containerHeight: number
  message: string
  isActive: boolean
}

export default Vue.extend({
  name: 'InvoicingDialog',

  components: {
    ProgressCircular
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentPeriod: Object as () => DatePeriod,
    departmentId: Number,
    invoicingDialogData: Object as () => Invoice
  },

  data (): ComponentData {
    return {
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      },
      loading: false,
      isSaveInProgress: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      gridDataClosed: [],
      gridDataNotClosed: [],
      headers: [
        { text: this.$t('invoicing.employee').toString(), value: 'employeeName', align: 'start' },
        { text: this.$t('invoicing.personNumberShort').toString(), value: 'personalNumber', align: 'start' },
        { text: this.$t('invoicing.shortName').toString(), value: 'shortName', align: 'start'}
      ],
      overlayNoRowsTemplate: this.$t('errors.noRowsToShow').toString(),
      period: undefined,
      closedSelected: [],
      containerHeight: 400,
      message: '',
      isActive: true
    }
  },

  watch: {
    currentPeriod (newVal: DatePeriod): void {
      if(newVal) {
        this.period = this.currentPeriod
        this.fetchData()
      }
    },

    departmentId (newVal: number | undefined): void {
      if(newVal) {
        this.fetchData()
      }
    }
  },

  computed: {
    getPosition (): Object {
      const top : number = (window.innerHeight - 100 - 400) / 2
      const left : number = (window.innerWidth - 900) / 2
      return {top: `${top}px`, left: `${left}px`}
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getTitle (): string {
      let begin = moment(this.currentPeriod.startDate).startOf(DatePeriodEnum.Month)
      let end = moment(this.currentPeriod.endDate).endOf(DatePeriodEnum.Month)

      if(this.period) {
        begin = moment(this.period.startDate).startOf(DatePeriodEnum.Month)
        end = moment(this.period.endDate).endOf(DatePeriodEnum.Month)
      }

      let beginStr, endStr

      const beginMonth = begin.format('MMM')
      const endMonth = end.format('MMM')

      if (beginMonth === endMonth) {
        beginStr = begin.format('DD')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      } else {
        beginStr = begin.locale(this.selectedLocale).format('DD MMM')
        endStr = end.locale(this.selectedLocale).format('DD MMM')
      }
      const yearStr = end.format('YYYY')

      return `${beginStr} - ${endStr} ${yearStr}`
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onRefreshButtonClick (): void {
      this.fetchData()
    },

    selectAll (): void {
      this.closedSelected = this.gridDataClosed
    },

    onCreateInvoicesClick (): void {
      let payloadData: InvoiceDataPayload[] = []

      this.closedSelected.forEach((item: Invoicing) => {
        return item.tree[0].details.forEach((i: InvoicingDetail) => {
          payloadData.push({EmployeeId: item.employeeId, AddressNumber: i.addressNumber})
        })
      })

      const payload: CreateInvoicesPayload = {
        FromDate: moment(this.period!.startDate).format('YYYY-MM-DD HH:mm'),
        ToDate: moment(this.period!.endDate).format('YYYY-MM-DD HH:mm'),
        Data: payloadData
      }

      this.createInvoices(payload)
    },

    async createInvoices (payload: CreateInvoicesPayload): Promise<void> {
      try {
        this.isSaveInProgress = true
        const response: ResponseBase = await this.$store.dispatch(CREATE_INVOICES, payload)
        if(!response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
      } finally {
        this.isActive = true
        this.getinvoicingStatus()
        this.showSnackbar = true
        this.isSaveInProgress = false
      }
    },

    async fetchData (): Promise<void> {
      const payload: InvoicePayload = {
        year: moment(this.period!.startDate).format('YYYY'),
        month: this.period!.number,
        department: this.departmentId
      }

      try {
        this.loading = true
        const response: InvoiceResponse = await this.$store.dispatch(FETCH_INVOICING_DATA, payload)
        /*if(response.InvoicingInProgress) {
          this.onCloseButtonClick()
        }*/
        if(!response.IsError) {
          const data: Invoice = Invoice.createFromResponse(response)
          this.gridDataClosed = data.invoicing
          this.gridDataNotClosed = data.notInvoicing
          this.selectAll()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
        this.getinvoicingStatus()
      }
    },

    dragMouseDown: function (event: any) {
      event.preventDefault()
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event: any) {
      // @ts-ignore
      const container: HTMLElement = this.$refs['draggableContainer']
      event.preventDefault()

      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY

      if((container.offsetTop - this.positions.movementY) > -64 && (container.offsetTop - this.positions.movementY + container.clientHeight + 64) < event.view.innerHeight) {
        container.style.top = (container.offsetTop - this.positions.movementY) + 'px'
      } else if ((container.offsetTop - this.positions.movementY) < -64) {
        container.style.top = -64 + 'px'
      } else if ((container.offsetTop - this.positions.movementY) + container.clientHeight + 64 > event.view.innerHeight) {
        container.style.top = (event.view.innerHeight - (container.clientHeight + 64)) + 'px'
      }

      if((container.offsetLeft - this.positions.movementX) > 0 && (container.offsetLeft - this.positions.movementX + container.clientWidth + 18) < event.view.innerWidth) {
        container.style.left = (container.offsetLeft - this.positions.movementX) + 'px'
      } else if((container.offsetLeft - this.positions.movementX) < 0) {
        container.style.left = 0 + 'px'
      } else if((container.offsetLeft - this.positions.movementX + container.clientWidth + 18) > event.view.innerWidth) {
        container.style.left = (event.view.innerWidth - container.clientWidth - 18) + 'px'
      }
    },

    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    },

    onResize (): void {
      if(this.$refs['draggableContainer'] && this.$refs['cardActions']) {
        // @ts-ignore
        const container: HTMLElement = this.$refs['draggableContainer']
        // @ts-ignore
        const actions: HTMLElement = this.$refs['cardActions']
        if(container.clientHeight - 64 - 38 !== this.containerHeight) {
          this.containerHeight = container.clientHeight -64 - 38 - actions.clientHeight
        }
      }
    },

    async getinvoicingStatus (): Promise<void> {
      const payload: InvoicePayload = {
        year: moment(this.period!.startDate).format('YYYY'),
        month: this.period!.number,
        department: this.departmentId
      }

      try {
        this.loading = true
        const response: InvoiceStatusResponse = await this.$store.dispatch(FETCH_INVOICING_STATUS, payload)
        if(!response.IsError && response.Data && response.Data.Message) {
          this.message = response.Data.Message
          this.isActive = response.Data.Active
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
  },

  mounted (): void {
    this.period = this.currentPeriod
    this.getinvoicingStatus()
    this.gridDataClosed = this.invoicingDialogData.invoicing
    this.gridDataNotClosed = this.invoicingDialogData.notInvoicing
    this.selectAll()
  }
})
